import { inject, observer } from 'mobx-react';
import React from 'react';
import { State } from './types';
import { IValueMap } from 'mobx-react/dist/types/IValueMap';

export default function connect<MappedProps extends IValueMap>(
  mapStoreToProps: (store: State, props?: any) => MappedProps
) {
  return function <WrappedProps>(
    WrappedComponent:
      | React.ComponentClass<WrappedProps>
      | React.FunctionComponent<WrappedProps>
  ) {
    const ConnectedComponent = inject(mapStoreToProps)(
      observer(WrappedComponent)
    );
    type TNewType = Omit<WrappedProps, keyof MappedProps>
    return ConnectedComponent as any as React.FunctionComponent<TNewType> | React.ComponentClass<TNewType>;
  };
}
